/* eslint-disable complexity */
import { TRelatedBlogs } from '../articles/types'
import { EntityStats, StockDetails } from '@/components/Stocks/Widgets/types'

export const getNavItems = ({
  stock_details,
  showFNO,
  inStocksRelatedBlogs,
  entity_stats,
}: {
  stock_details?: StockDetails
  entity_stats?: EntityStats
  showFNO: boolean
  inStocksRelatedBlogs: TRelatedBlogs | null
}) => {
  const {
    research: entityDetailsResearch,
    analyst_forecast,
    stock_peers,
    company_details,
    mutual_fund_holdings,
    news_items,
    insights_data,
    valuations,
    linked_indexes = [],
    management_data = [],
    interest_data = [],
    sp,
    pnl,
    cf,
  } = stock_details ?? {}
  const { consensus = {} } = analyst_forecast ?? {}
  const { performance } = entity_stats ?? {}

  const { infographics, corp_announcements } = entityDetailsResearch ?? {}

  const pnlQuarterly = pnl?.contents?.find(
    el => el?.name?.toLowerCase?.() === 'quarterly',
  )
  const pnlAnnual = pnl?.contents?.find(
    el => el?.name?.toLowerCase?.() === 'annual',
  )

  return [
    { id: 'share-price', label: 'Share Price' },
    !!performance && {
      id: 'performance',
      label: 'Performance',
    },
    !!stock_peers?.length && {
      id: 'fundamentals',
      label: 'Fundamentals',
    },
    !!valuations && {
      id: 'valuation',
      label: 'Valuation',
    },
    !!stock_peers?.length && {
      id: 'peers',
      label: 'Peers',
    },
    consensus?.sentiment && {
      id: 'analyst-recommendation',
      label: 'Analyst Recommendation',
    },
    analyst_forecast && {
      id: 'target-price',
      label: 'Target Price',
    },
    !!interest_data.length && {
      id: 'sentiment',
      label: 'Sentiment',
    },
    (!!pnlQuarterly || !!pnlAnnual) && {
      id: 'pnl',
      label: 'Profit & Loss',
    },
    cf?.contents?.length && {
      id: 'cf',
      label: 'Cash Flow',
    },
    (mutual_fund_holdings?.length || !!sp?.contents?.length) && {
      id: 'shareholding',
      label: 'Shareholding',
    },
    corp_announcements && {
      id: 'corp-action',
      label: 'Corporate Actions',
    },
    (!!inStocksRelatedBlogs?.length || news_items?.news_timelines) && {
      id: 'blogs-news',
      label: 'Blogs & News',
    },
    !!linked_indexes?.length && { id: 'indices', label: 'Indices' },
    (!!insights_data || infographics?.heading) && {
      id: 'insights',
      label: 'Insights',
    },
    showFNO && { id: 'futures-options', label: 'Futures & Options' },
    (company_details || !!management_data.length) && {
      id: 'company-info',
      label: 'Company Info',
    },
    {
      id: 'faqs',
      label: 'FAQs',
    },
  ].filter(Boolean) as { id: string; label: string }[]
}
